module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "copy_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "prol_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofStorms_prol_1"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofStorms_chap_1"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofStorms_chap_2"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_chap_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "epil_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_epil_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "auth_bio_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_auth_bio_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "teas_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_teas_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Border Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "appe_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_appe_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "appe_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofStorms_appe_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dish")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e74276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofStorms_toc.vue
// module id = 63
// module chunks = 0